var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 29,
    viewBox: "0 0 36 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2429 20.599L18.1439 14.5L12.0449 20.599",
    stroke: "#F19B9E",
    strokeWidth: 1.52475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1436 14.5V28.2228",
    stroke: "#F19B9E",
    strokeWidth: 1.52475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9364 24.2434C32.4235 23.4327 33.5983 22.1498 34.2754 20.5972C34.9524 19.0446 35.0932 17.3107 34.6754 15.6693C34.2576 14.0278 33.305 12.5722 31.9681 11.5323C30.6312 10.4923 28.986 9.92714 27.2922 9.92602H25.371C24.9095 8.1409 24.0493 6.48364 22.8551 5.07882C21.6609 3.674 20.1637 2.55819 18.4762 1.81526C16.7887 1.07234 14.9547 0.721634 13.1122 0.789522C11.2696 0.857409 9.46642 1.34212 7.83815 2.20721C6.20989 3.0723 4.79892 4.29526 3.71133 5.78415C2.62374 7.27304 1.88783 8.98911 1.55892 10.8034C1.23002 12.6176 1.31668 14.4828 1.81239 16.2587C2.3081 18.0346 3.19996 19.6751 4.42092 21.0567",
    stroke: "#F19B9E",
    strokeWidth: 1.52475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2429 20.599L18.1439 14.5L12.0449 20.599",
    stroke: "#F19B9E",
    strokeWidth: 1.52475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.fbf523b7ff05b6028b48ff18a0182ffb.svg";
export { ForwardRef as ReactComponent };